import { VideoExtensionType } from "../components/VideoPlayer";
import { CarouselFile, CarouselFileType } from "../types/CarouselFile";

// Carousel file definitions for the home page.
// Commented entries are saved for future use when additional assets are ready.
export const HomePageCarouselImages: CarouselFile[] = [
  {
    fileType: CarouselFileType.Image,
    path: "/images/main-design-carousel.png",
    smallPath: "/images/main-design-carousel-sm.png",
    className: "carousel-image-full",
    smallClassName: "carousel-image-scaled-down",
    interval: 1, // Hidden — acts as placeholder for future first slide
  },
  {
    fileType: CarouselFileType.Video,
    path: "/videos/Americana_Homepage_Video_090626.mp4",
    smallPath: "/videos/Americana_Homepage_Video_090626_9x16.mp4",
    poster: "/images/homepage-video-poster-090626.jpg",
    smallPoster: "/images/homepage-video-poster-090626-sm.jpg",
    className: "carousel-image-full",
    smallClassName: "carousel-image-scaled-down",
    extensionType: VideoExtensionType.MP4,
    showShopButton: true,
  },
];

export const LocalBrandFiles: CarouselFile[] = [];
